import { connect } from 'react-redux'
// @ts-ignore
import { setCustomStory } from 'store/entities/identity/actions'
// @ts-ignore
import UserStoryForm from 'app/domains/common/UserStoryForm'

const mapDispatchToProps = {
  setCustomStory,
}

export default connect<{}, {}, any>(null, mapDispatchToProps)(UserStoryForm)
